import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_DIALOG_STIL } from './fiko-dialog-stil';
import { FikoDuzlemSecici } from './FikoDuzlemSecici';

/**
 * CATIA Plane Definition (GSD wireframe) — referans düzlem.
 * Tür: Ofset (temel düzlem+mesafe) · 3 Nokta · Eğriye Normal · Noktadan Paralel · İki Çizgi.
 */
@Component({
  selector: 'fikoyt-duzlem-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoDuzlemSecici],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Düzlem Türü</div>
      <div class="sd-row"><label>Tür</label>
        <select [ngModel]="el.duzlemTip || 'ofset'" (ngModelChange)="set('duzlemTip',$event)">
          <option value="ofset">Ofset (Temel + Mesafe)</option>
          <option value="paralelNokta">Noktadan Paralel</option>
          <option value="uc-nokta">Üç Nokta (3 Points)</option>
          <option value="egriNormal">Eğriye Normal</option>
          <option value="iki-cizgi">İki Çizgiyi İçeren</option>
        </select>
      </div>
    </div>

    @if((el.duzlemTip || 'ofset') === 'ofset'){
      <div class="sd-grup"><div class="sd-bas">Temel Düzlem & Ofset</div>
        <div class="sd-row"><label>Temel</label>
          <fikoyt-duzlem-secici [element]="el" [yonetici]="yon"></fikoyt-duzlem-secici></div>
        <div class="sd-row"><label>Ofset</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.splitOfset ?? 0" (ngModelChange)="setNum('splitOfset',$event)"/><span>mm</span></div></div>
        <button class="sd-btn" (click)="setNum('splitOfset', -(el.splitOfset ?? 0))">⇅ Yönü Ters Çevir</button>
      </div>
    } @else if(el.duzlemTip === 'paralelNokta'){
      <div class="sd-grup"><div class="sd-bas">Noktadan Paralel</div>
        <div class="sd-row"><label>Temel</label>
          <fikoyt-duzlem-secici [element]="el" [yonetici]="yon"></fikoyt-duzlem-secici></div>
        <div class="sd-row"><label>Nokta</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        @if(!noktalar().length){ <div class="sd-bos">Önce bir nokta oluştur.</div> }
      </div>
    } @else if(el.duzlemTip === 'uc-nokta'){
      <div class="sd-grup"><div class="sd-bas">Üç Nokta</div>
        <div class="sd-row"><label>Nokta 1</label><select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Nokta 2</label><select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref2','nokta3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Nokta 3</label><select [ngModel]="el.ref3 ?? -1" (ngModelChange)="setNum('ref3',$event)"><option [value]="-1">— seç —</option>@for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref3','nokta3d')" title="3D'den seç">🎯</button></div>
        @if(noktalar().length < 3){ <div class="sd-bos">Önce 3 nokta oluştur.</div> }
      </div>
    } @else if(el.duzlemTip === 'egriNormal'){
      <div class="sd-grup"><div class="sd-bas">Eğriye Normal</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of egriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Konum (0-1)</label><div class="sd-num"><input type="number" min="0" max="1" step="0.05" [ngModel]="el.oran ?? 0.5" (ngModelChange)="setNum('oran',$event)"/></div></div>
        @if(!egriler().length){ <div class="sd-bos">Önce bir eğri oluştur.</div> }
      </div>
    } @else {
      <div class="sd-grup"><div class="sd-bas">İki Çizgiyi İçeren</div>
        <div class="sd-row"><label>Çizgi 1</label><select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)"><option [value]="-1">— seç —</option>@for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Çizgi 2</label><select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)"><option [value]="-1">— seç —</option>@for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }</select><button class="sd-pick" (click)="ref3d('ref2','cizgi3d')" title="3D'den seç">🎯</button></div>
        @if(cizgiler().length < 2){ <div class="sd-bos">Önce 2 çizgi oluştur.</div> }
      </div>
    }

    <div class="sd-grup"><div class="sd-bas">Görünüm</div>
      <div class="sd-row"><label>Boyut</label><div class="sd-num"><input type="number" min="2" step="5" [ngModel]="el.duzlemBoyut ?? 50" (ngModelChange)="setNum('duzlemBoyut',$event)"/><span>mm</span></div></div>
    </div>

    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoDuzlemDialog {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }
  noktalar(): any[] { return this.yonetici?.noktaSecenekleri?.(this.element) || []; }
  egriler(): any[] { return this.yonetici?.tumEgriSecenekleri?.(this.element) || []; }
  cizgiler(): any[] { return this.yonetici?.egriSecenekleri?.(this.element) || []; }
  ref3d(anahtar: string, tip: string): void { this.yonetici?.refSecBaslat?.(this.element, anahtar, [tip], () => this.CD.markForCheck()); }
  set(a: string, v: any): void { this.yonetici?.padGuncelle(this.element, a, v); this.CD.markForCheck(); }
  setNum(a: string, v: any): void { const n = +v; if (!isNaN(n)) this.yonetici?.padGuncelle(this.element, a, n); this.CD.markForCheck(); }
  private kapat(): void { this.yonetici?.refSecBitir?.(); (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
